module.exports = __webpack_public_path__ + "img/card_therapy_200.90a9cda8.jpg";